import * as React from "react";
import { useTranslation } from "react-i18next";
import { FunctionComponent } from "react";

//MUI Icons
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

//Custom Components
import CardActionButton from "@/ui/Card/CardActionButton";

//Types
import { ICardActionButtonDetail } from "@/@types/ui/Card";

const CardActionButtonActivate: FunctionComponent<ICardActionButtonDetail> = (props) => {
  const { t } = useTranslation();

  return (
    <CardActionButton startIcon={<CheckCircleIcon />} {...props} ariaLabel="Activate" ariaControls="Activate">
      {t("buttons.activate")}
    </CardActionButton>
  );
};

export default CardActionButtonActivate;
